import './expired.styles.scss';
import { useContext, useState, useEffect } from 'react';
import { SimContext } from '../../../api/SimContext';
import HeadingSecondary from '../../../components/typography/headings/heading-secondary/heading-secondary.component';
import { IoMdSearch } from 'react-icons/io';
import Dropdown from '../../../components/dropdown/dropdown.component';
import { IoReloadCircleSharp } from 'react-icons/io5';
import { MdArrowBack } from 'react-icons/md';
import { MdArrowForward } from 'react-icons/md';
import { isActionCreator } from '@reduxjs/toolkit';
const ExpiredScreen = ({setExpirationCount}) => {
    const { allSims, offers, sellSim, reloadKey, setReloadKey, simToInv, pageCount, setPageCount } = useContext(SimContext);
    const [isSpinning, setIsSpinning] = useState(false);
    const [selections, setSelections] = useState({});
    const handleReload = () => {
      setIsSpinning(true);
      setTimeout(() => {
        setReloadKey(reloadKey + 1);
        setIsSpinning(false);
      }, 1200); // Match this duration with the CSS animation duration
    };
    const [searchTerm, setSearchTerm] = useState('');
    const productOptions = offers.map(offer => ({
      'name': offer.name,
      'id': offer.id
    }));
    // const productOptions = offers.map(offer => ({ label: offer.name, value: offer.id })); // NIEUW
    const durationOptions = [
      { name: "1 day", dayNumber: 1 },
      { name: "3 days", dayNumber: 3 },
      { name: "7 days", dayNumber: 7 }
  ];

  const extractActivationDate = (tags) => {
    const activationDateTags = tags
      .filter(tag => tag.startsWith('activatedDate='))
      .map(tag => {
        const [date, index] = tag.split('#index=');
        return {
          date: date.split('=')[1],
          index: parseInt(index, 10)
        };
      });
  
    if (activationDateTags.length === 0) return { activationDate: null };
  
    const latestActivationDateTag = activationDateTags.reduce((max, current) => current.index > max.index ? current : max, { date: null, index: -1 });
  
    return { activationDate: latestActivationDateTag.date };
  };
  
    const [filteredExpiredSims, setFilteredExpiredSims] = useState([]);
    function formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
    useEffect(() => {
        const filtered = allSims.filter(sim => {
          // Include only SIMs that match the exclusion conditions
         if (sim.offer === "NO OFFER" && sim.tags && sim.tags.some(tag => tag.includes("Sold"))) {
            // Keep the search functionality intact
            return (
              (sim.msisdn && sim.msisdn.toString().toLowerCase().includes(searchTerm.toLowerCase())) || 
              (sim.eid && sim.eid.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
              (sim.offer && sim.offer.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
              (sim.tags && sim.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase())))
            );
          }
          
          return false; 
        });
      
        setFilteredExpiredSims(filtered);
      }, [allSims, searchTerm]);
      useEffect(() => {
        setExpirationCount(filteredExpiredSims.length)
      }, [filteredExpiredSims.length]);

      const handleBackClick = () => {
        if (pageCount > 0) {
            setPageCount(prevCount => prevCount - 1); 
        }
    };
    
    const handleForwardClick = () => {
        setPageCount(prevCount => prevCount + 1); 
    };
  
    return (
      <div className='content-container-component'>
          <div className="messages-container">
          <div className='table-heading-container'>
              <IoReloadCircleSharp size={28} color='black' onClick={handleReload} style={{ cursor: 'pointer'}} className={`reload-div ${isSpinning ? 'spin-animation' : ''}`} />
              {/* <div className='page-flip-container'>
                <MdArrowBack size={26} color='black' onClick={handleBackClick} />
                <div className='page-flipper-text'>{pageCount + 1}</div>
                <MdArrowForward size={26} color='black' onClick={handleForwardClick} />
              </div> */}
              <div className="search-container">
              <IoMdSearch size={28} color= '#646272'/>
                <input 
                    type="text" 
                    className="search-input" 
                    placeholder="Search SIM"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>
            </div>
            <div className='table-scroll-container'>
              <div className='panel-small'>
                <div className='panel-heading'> 
                  <div className='inner-panel-heading'>
                    <div className='header-container-reseller'>
                      <HeadingSecondary text={`MSISDN - SIM EID`} mode={'light'}/>
                    </div>
                    <div className='header-container-reseller'>
                      <HeadingSecondary text={`Activation Date`} mode={'light'}/>
                    </div>
                    <div className='header-container-reseller'>
                      <HeadingSecondary text={`Expiration Date`} mode={'light'}/>
                    </div>
                    <div className='header-container-reseller'>
                      <HeadingSecondary text={`Action`} mode={'light'}/>
                    </div>
                  </div>
                </div>
                    <div className='panel-content-container'>
                        <div className='sim-heading-container'>
                            <div className='sortby-container'>
                            </div>
                        </div>
                        <div className='scroll-container'>
                          {filteredExpiredSims.map(sim => {
                            const { activationDate } = extractActivationDate(sim.tags);
              
                            return (
                              <div key={sim.eid} className="reseller-block-table">
                                <div className="sim-info-reseller">
                                  <div className="sim-text-bold">
                                    {sim.msisdn}
                                    <br />
                                    {sim.eid}
                                  </div>
                                </div>
                                <div className='dropdown-container'>
                                  <div className="duration-block">
                                    <div className='sim-text'>{formatDate(activationDate)}</div>
                                  </div>
                                </div>
                                <div className='dropdown-container'>
                                  <div className="duration-block">
                                    <div className='sim-text'>{formatDate(sim.activatedDate)}</div>
                                  </div>
                                </div>
                                <div className='sell-button-container' onClick={() => {
                                  if (!selections[sim.id]?.sold) {
                                    simToInv(sim.id);
                                    setSelections(prev => ({
                                      ...prev,
                                      [sim.id]: {
                                        ...prev[sim.id],
                                        inv: true  
                                      }
                                    }));
                                    setTimeout(() => {
                                      setFilteredExpiredSims(currentSims => currentSims.filter(s => s.id !== sim.id));
                                    }, 800); 
                                  } else {
                                    console.log("SIM is already out of inventory."); 
                                  }
                                }}>
                                  <div className={`${selections[sim.id]?.inv ? 'loader' : 'sell-block'}`}> 
                                    <div className='sim-text'>{selections[sim.id]?.inv ? '' : 'Set Inventory'}</div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                        
                    </div>
              </div>
          </div>
          </div>
      </div>
  );
};

export default ExpiredScreen;